import React from 'react';

const ResultsFooter: React.FC = () => {
  return (
    <footer className="text-center text-gray-500 text-sm border-t border-gray-200 pt-8">
      <div className="flex items-center justify-center mb-6">
        <span>Hecho con orgullo para la comunidad profesional latina</span>
      </div>
      <div className="text-xs text-gray-400 space-y-2">
        <p>© 2025 YOJ Inc. Todos los derechos reservados.</p>
        <p><b>Test Latino™ es una marca registrada de YOJ Inc.</b> Todas las demás marcas son propiedad de sus respectivos dueños.</p>
        <p>El <b>Test Latino™</b> es propiedad intelectual de YOJ Inc. y fue desarrollado por José Piñero, ampliamente reconocido como el Top Coach para Latinos. <b>Latino Leadership Performance</b> es una división comercial de YOJ Inc.</p>
        <p>La reproducción, distribución o uso no autorizado de este test, sus preguntas, arquetipos o contenido relacionado está estrictamente prohibido y protegido por las leyes de derechos de autor y marcas registradas en EE. UU.</p>
        <p className="mt-4">
          <a 
            href="https://www.testlatino.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-orange-500 hover:text-orange-600"
          >
            www.testlatino.com
          </a>
        </p>
      </div>
    </footer>
  );
};

export default ResultsFooter;